import React, {
  SetStateAction,
  useState,
  Dispatch,
  ReactNode,
  useEffect,
} from "react";
import styled from "styled-components";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowDropup } from "react-icons/io";

type SelectComponentProps = {
  label: string;
  selectItem: number | string;
  setSelectItemAction?: Dispatch<SetStateAction<number | string>>;
  items: Array<{ id: number | string; value: string }>;
  icon?: ReactNode;
  prefix?: string;
  nullValue?: boolean;
};

const SelectStyle = styled.div`
  position: relative;
  color: #393432;
  width: 100%;

  ul {
    position: absolute;
    background: #fafafa;
    border: 1px solid #e6e4dc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 12px;
    z-index: 9999;
    margin: 10px 0 0 0;
    padding: 0;
    width: inherit;

    li {
      padding: 4px 10px;
      list-style: none;

      &:hover {
        cursor: pointer;
        background: #f2f0e9;
      }
    }
  }
`;

const SelectButtonStyle = styled.div`
  display: flex;
  align-items: center;
  background: #f2f0e9;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  justify-content: space-around;
  width: inherit;
  height: 50px;

  &:hover {
    background: #696767;
    color: white;
  }
`;

const LabelLeftStyle = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`;

const LabelRightStyle = styled.div`
  display: flex;
`;

const Select: React.FC<SelectComponentProps> = ({
  label,
  selectItem,
  setSelectItemAction,
  items,
  icon,
  prefix,
  nullValue,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [displayItemValue, setDisplayItemValue] = useState<number | string>();

  useEffect(() => {
    if (!selectItem) return;
    const item = items.find((item) => item.id === selectItem);
    setDisplayItemValue(item.value);
  }, []);

  const SelectList = (
    items: Array<{ id: number | string; value: string }>,
    prefix: string,
    nullValue: boolean
  ) => {
    return (
      <ul>
        {nullValue && (
          <li
            onClick={() => {
              setOpen(!open);
              setSelectItemAction(null);
              setDisplayItemValue(null);
            }}
          >
            選択を外す
          </li>
        )}
        {items.map((object) => {
          return (
            <li
              key={object.id}
              onClick={() => {
                setOpen(!open);
                setSelectItemAction(object.id);
                setDisplayItemValue(object.value);
              }}
            >
              {prefix}
              {object.value}
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <SelectStyle>
      <SelectButtonStyle onClick={() => setOpen(!open)}>
        <LabelLeftStyle>
          {icon}
          {displayItemValue && prefix}
          {displayItemValue || label}
        </LabelLeftStyle>
        <LabelRightStyle>
          {open ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
        </LabelRightStyle>
      </SelectButtonStyle>
      {open && SelectList(items, prefix, nullValue)}
    </SelectStyle>
  );
};

export default Select;
